export default {
  isLoading: false,
  hasLoaded: false,
  error: null,

  contractNotes: [],
};
